<template>
    <div class="iconOuter">
        <div class="iconPosition">
            <div class="iconFormPlus">
                <div class="formPlus">
                    <van-icon name="plus" @click="fillOutForm" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'iconPlus',
    methods: {
        fillOutForm() {
            this.$router.push('/fillOutForm')
        },
    },
};
</script>

<style lang="less" scoped>
.iconOuter {
    width: 100%;
    min-width: 375px;
    max-width: 740px;
    height: 0;
    position: fixed;
    bottom: 150px;
    .iconPosition {
        position: absolute;
        bottom: 100px;
        top: 0;
        right: 30px;
        .iconFormPlus {
            position: absolute;
            right: 0;
            .formPlus {
                width: 60px;
                height: 60px;
                line-height: 60px;
                background: #1989fa;
                // opacity: .8;
                border-radius: 50%;
                color: #fff;
                font-size: 34px;
                text-align: center;
            }
        }
    }
}
</style>